import  { useMemo, memo } from 'react';

import { Checkbox } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { CissNumberField } from 'components/fields';
import { PanelGrid } from 'components/grid';
import { useQueryBandaPreco } from 'pages/cadastro/loja/hooks';
import { LojaBandaPreco } from 'pages/cadastro/loja/types';

/**
 * Retorna os dados formatados para o grid.
 */
const getRows = (data: LojaBandaPreco[] = []): GridRowsProp =>
    data.map((item, index) => ({
        id: index,
        idBandaPreco: item.idBandaPreco,
        dsBandaPreco: item.bandaPreco.dsBandaPreco,
        vlPercentual: item.vlPercentual,
        fgAtivo: item.fgAtivo,
        bandaPreco: {
            dsBandaPreco: item.bandaPreco.dsBandaPreco,
            idBandaPreco: item.idBandaPreco,
        },
    }));

export const LojaBandaPrecoGrid = memo(function LojaBandaPrecoGrid({
    lojaBandaPrecos,
    setFieldValue,
    disabled = false,
}: {
    lojaBandaPrecos?: LojaBandaPreco[];
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
    disabled?: boolean;
}) {
    const { isFetching } = useQueryBandaPreco();

    const rows = useMemo(() => getRows(lojaBandaPrecos), [lojaBandaPrecos]);

    const columns = useMemo(
        (): GridColDef[] => [
            { field: 'dsBandaPreco', headerName: 'Banda de Preço', minWidth: 120, flex: 1 },
            {
                field: 'fgAtivo',
                headerName: 'Ativo',
                filterable: false,
                sortable: false,
                hideable: false,
                maxWidth: 50,
                disableColumnMenu: false,
                renderCell: ({ row }) => {
                    return (
                        <Checkbox
                            checked={row.fgAtivo}
                            disabled={disabled}
                            onChange={(e) => setFieldValue(`lojaBandaPrecos[${row.id}]`, { ...row, fgAtivo: e.target.checked })}
                        />
                    );
                },
            },
            {
                field: 'vlPercentual',
                align: 'center',
                headerName: 'Valor',
                headerAlign: 'center',
                sortable: false,
                hideable: false,
                filterable: false,
                disableColumnMenu: true,
                width: 140,
                renderCell: ({ row }) => {
                    return (
                        <CissNumberField
                            size="small"
                            inputType="decimal"
                            disabled={disabled}
                            value={row.vlPercentual}
                            onChange={(e) => setFieldValue(`lojaBandaPrecos[${row.id}]`, { ...row, vlPercentual: e.target.value })}
                        />
                    );
                },
            },
        ],
        [],
    );

    return <PanelGrid hideFooter={true} rows={rows} reload={false} loading={isFetching} columns={columns} remote={false} />;
});
